import React, { useState, useEffect } from 'react';
import { adminApi } from '../services/api';

const LOG_TYPE_COLORS = {
  CLIENT_LOGIN_SUCCESS:  { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
  CLIENT_LOGIN_FAILED:   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  CLIENT_OTP_SENT:       { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
  ADMIN_LOGIN_SUCCESS:   { bg: '#fdf4ff', color: '#9333ea', border: '#e9d5ff' },
  DEALER_LOGIN_SUCCESS:  { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
  DEALER_SSO_GENERATED:  { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
  SQUAREOFF_PLACED:      { bg: '#fff1f2', color: '#be123c', border: '#fda4af' },
  BF_FILE_UPLOADED:      { bg: '#f0fdf4', color: '#15803d', border: '#86efac' },
  CLIENT_CREATED:        { bg: '#eff6ff', color: '#1d4ed8', border: '#93c5fd' },
  CLIENT_UPDATED:        { bg: '#eff6ff', color: '#1d4ed8', border: '#93c5fd' },
  SECURITY_BLOCKED:      { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  ALERT_WHATSAPP_SENT:   { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
  DEFAULT:               { bg: '#f9fafb', color: '#374151', border: '#e5e7eb' },
};

const ACTOR_TYPE_COLORS = {
  CLIENT:  { bg: '#eff6ff', color: '#1d4ed8' },
  ADMIN:   { bg: '#fdf4ff', color: '#9333ea' },
  DEALER:  { bg: '#fff7ed', color: '#c2410c' },
  SYSTEM:  { bg: '#f9fafb', color: '#374151' },
  BMS:     { bg: '#f0fdf4', color: '#15803d' },
};

export default function SystemLogsPanel() {
  const [logs,    setLogs]    = useState([]);
  const [summary, setSummary] = useState(null);
  const [total,   setTotal]   = useState(0);
  const [page,    setPage]    = useState(1);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    type: '', actor_type: '', ucc: '', status: '', from: '', to: '', search: ''
  });

  const fetchLogs = async (pg = 1) => {
    setLoading(true);
    try {
      const params = { page: pg, limit: 50, ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v)) };
      const [logsRes, summaryRes] = await Promise.all([
        adminApi.get('/admin/logs', { params }),
        adminApi.get('/admin/logs/summary')
      ]);
      setLogs(logsRes.data.logs || []);
      setTotal(logsRes.data.total || 0);
      setSummary(summaryRes.data.summary);
      setPage(pg);
    } catch (err) {
      console.error('Failed to fetch logs:', err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchLogs(1); }, []);

  const handleExport = () => {
    const params = new URLSearchParams(Object.fromEntries(Object.entries(filters).filter(([, v]) => v)));
    const token  = localStorage.getItem('nb_admin_token');
    window.open(`/api/admin/logs/export?${params}&token=${token}`);
  };

  const getLogStyle = (type) => LOG_TYPE_COLORS[type] || LOG_TYPE_COLORS.DEFAULT;
  const getActorStyle = (type) => ACTOR_TYPE_COLORS[type] || ACTOR_TYPE_COLORS.SYSTEM;

  const summaryCards = summary ? [
    { label: 'Client Logins Today',   value: summary.client_logins_today,  color: '#16a34a' },
    { label: 'Admin Logins Today',    value: summary.admin_logins_today,   color: '#9333ea' },
    { label: 'Dealer Logins Today',   value: summary.dealer_logins_today,  color: '#c2410c' },
    { label: 'OTPs Sent Today',       value: summary.otp_sent_today,       color: '#2563eb' },
    { label: 'Sq-Offs Today',         value: summary.squareoff_today,      color: '#dc2626' },
    { label: 'WhatsApp Alerts Today', value: summary.whatsapp_today,       color: '#16a34a' },
    { label: 'Failed Logins Today',   value: summary.failed_logins_today,  color: '#dc2626' },
    { label: 'Security Blocks Today', value: summary.security_blocks_today,color: '#dc2626' },
  ] : [];

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif" }}>

      {/* Summary Cards */}
      {summary && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 18 }}>
          {summaryCards.map(c => (
            <div key={c.label} style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 8, padding: '12px 14px' }}>
              <div style={{ fontSize: 10, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 5 }}>{c.label}</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: c.color }}>{c.value ?? 0}</div>
            </div>
          ))}
        </div>
      )}

      {/* Filters */}
      <div style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 10, padding: '14px 18px', marginBottom: 14 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr) auto auto', gap: 10, alignItems: 'end' }}>
          <div>
            <div style={s.lbl}>Search</div>
            <input style={s.inp} placeholder="UCC, actor, details..."
              value={filters.search} onChange={e => setFilters(f => ({ ...f, search: e.target.value }))} />
          </div>
          <div>
            <div style={s.lbl}>Actor Type</div>
            <select style={s.inp} value={filters.actor_type} onChange={e => setFilters(f => ({ ...f, actor_type: e.target.value }))}>
              <option value="">All</option>
              <option value="CLIENT">Client</option>
              <option value="ADMIN">Admin</option>
              <option value="DEALER">Dealer</option>
              <option value="SYSTEM">System</option>
              <option value="BMS">BMS</option>
            </select>
          </div>
          <div>
            <div style={s.lbl}>Status</div>
            <select style={s.inp} value={filters.status} onChange={e => setFilters(f => ({ ...f, status: e.target.value }))}>
              <option value="">All</option>
              <option value="SUCCESS">Success</option>
              <option value="FAILED">Failed</option>
              <option value="BLOCKED">Blocked</option>
            </select>
          </div>
          <div>
            <div style={s.lbl}>From Date</div>
            <input style={s.inp} type="date" value={filters.from} onChange={e => setFilters(f => ({ ...f, from: e.target.value }))} />
          </div>
          <button style={s.filterBtn} onClick={() => fetchLogs(1)}>Apply</button>
          <button style={{ ...s.filterBtn, background: '#f8fafc', color: '#64748b', border: '0.5px solid #e2e8f0' }}
            onClick={() => { setFilters({ type: '', actor_type: '', ucc: '', status: '', from: '', to: '', search: '' }); fetchLogs(1); }}>
            Reset
          </button>
        </div>
      </div>

      {/* Log Table */}
      <div style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ padding: '12px 18px', borderBottom: '0.5px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>System Logs</span>
            <span style={{ fontSize: 11, color: '#64748b', marginLeft: 8 }}>{total.toLocaleString()} total records</span>
          </div>
          <button style={{ ...s.filterBtn, fontSize: 11 }} onClick={handleExport}>⬇ Export CSV</button>
        </div>

        {/* Header */}
        <div style={{ display: 'grid', gridTemplateColumns: '160px 80px 100px 100px 120px 1fr 80px 140px', padding: '9px 18px', background: '#f8fafc', borderBottom: '0.5px solid #e2e8f0' }}>
          {['Log Type', 'Actor', 'Type', 'UCC', 'IP', 'Details', 'Status', 'Time'].map(h => (
            <div key={h} style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>{h}</div>
          ))}
        </div>

        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Loading logs...</div>
        ) : logs.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>No logs found.</div>
        ) : logs.map((log, i) => {
          const logStyle   = getLogStyle(log.log_type);
          const actorStyle = getActorStyle(log.actor_type);
          return (
            <div key={log.log_id} style={{ display: 'grid', gridTemplateColumns: '160px 80px 100px 100px 120px 1fr 80px 140px', padding: '10px 18px', alignItems: 'center', borderBottom: i < logs.length - 1 ? '0.5px solid #f1f5f9' : 'none', background: log.status === 'FAILED' || log.status === 'BLOCKED' ? '#fff5f5' : '#fff' }}>
              <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4, background: logStyle.bg, color: logStyle.color, border: `0.5px solid ${logStyle.border}`, display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 155 }}>
                {log.log_type.replace(/_/g, ' ')}
              </span>
              <div style={{ fontSize: 11, color: '#374151', fontWeight: 500 }}>{log.actor || '—'}</div>
              <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4, background: actorStyle.bg, color: actorStyle.color, display: 'inline-block' }}>
                {log.actor_type || '—'}
              </span>
              <div style={{ fontSize: 11, color: '#374151' }}>{log.ucc || '—'}</div>
              <div style={{ fontSize: 10, color: '#94a3b8', fontFamily: 'monospace' }}>{log.ip_address || '—'}</div>
              <div style={{ fontSize: 11, color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={log.details}>{log.details || '—'}</div>
              <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4, display: 'inline-block', background: log.status === 'SUCCESS' ? '#f0fdf4' : log.status === 'FAILED' ? '#fef2f2' : '#fff7ed', color: log.status === 'SUCCESS' ? '#16a34a' : log.status === 'FAILED' ? '#dc2626' : '#c2410c' }}>
                {log.status}
              </span>
              <div style={{ fontSize: 10, color: '#94a3b8' }}>
                {new Date(log.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
              </div>
            </div>
          );
        })}

        {/* Pagination */}
        <div style={{ padding: '12px 18px', borderTop: '0.5px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 11, color: '#64748b' }}>
            Showing {((page - 1) * 50) + 1}–{Math.min(page * 50, total)} of {total.toLocaleString()}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ ...s.pageBtn, opacity: page === 1 ? 0.4 : 1 }} disabled={page === 1} onClick={() => fetchLogs(page - 1)}>← Prev</button>
            <span style={{ fontSize: 12, color: '#374151', padding: '5px 10px' }}>Page {page}</span>
            <button style={{ ...s.pageBtn, opacity: page * 50 >= total ? 0.4 : 1 }} disabled={page * 50 >= total} onClick={() => fetchLogs(page + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  lbl:       { fontSize: 11, fontWeight: 500, color: '#374151', marginBottom: 4 },
  inp:       { width: '100%', height: 34, border: '0.5px solid #e2e8f0', borderRadius: 6, padding: '0 10px', fontSize: 12, color: '#111', background: '#fff', outline: 'none', boxSizing: 'border-box' },
  filterBtn: { height: 34, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, padding: '0 16px', fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' },
  pageBtn:   { height: 30, background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 6, padding: '0 12px', fontSize: 11, color: '#374151', cursor: 'pointer', fontFamily: 'inherit' },
};